import styled from 'styled-components'

import { minmedia } from '../../styles/media-queries'
import { black, bordergray, gold, lightergray } from '../../styles/colors'

export const ItemLink = styled.a`
  display: block;
  width: 100%;
  color: ${black};
  text-decoration: none;
  border-bottom: 1px solid ${bordergray};

  &:last-child {
    border-bottom: 0;
  }
`

export const Item = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-bottom: 1px solid ${bordergray};
  padding: 1rem;
  cursor: pointer;
  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background: ${lightergray};
  }

  ${minmedia.medium`
    padding: 1.25rem 1.5rem;
  `};
`

export const IconContainer = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  fill: ${gold}

  display: flex;
  flex-wrap: wrap;
  align-items: center;

  svg {
    width: 2rem;
    height: auto;
  }

  ${minmedia.medium`

    svg {
      width: 2.5rem;
    }
  `}
`

export const Content = styled.div`
  font-size: 16px;
  padding-left: 1rem;
  width: calc(100% - 2.5rem);

  ${minmedia.medium`
    padding-left: 1.5rem;
  `};
`

export const Title = styled.div``

export const Subtitle = styled.div`
  font-style: italic;
  margin-top: 0.5rem;
  font-size: 16px;

  ${minmedia.medium`
    font-size: 16px;
  `};
`



// WEBPACK FOOTER //
// ./src/components/ContactPopup/styles.js